import { IntlProvider } from 'react-intl'

import enMessages from '../locales/en.json'

type IntlWrapperProps = {
  children: React.ReactNode
}

export default function IntlWrapper({ children }: IntlWrapperProps) {
  return (
    <IntlProvider locale={'en'} messages={enMessages}>
      {children}
    </IntlProvider>
  )
}
